<template>
  <div :class="['op--modal-container', {hide: !show}]">
    <div class="op--modal">
      <div class="op--modal-content">
        <div class="loader-box">
          <div class="loader-icon-box">
            <img src="../../assets/img/airline-loader.gif" class="app-imgloader" />
          </div>
          <!-- <i class="fas fa-spinner fa-spin slow-spin fa-3x"></i> -->
          <div class="msg-box">
            <div class="search-flight">Loading</div>
            <div class="sub-msg" v-if="(useLoadingMsg || useGroundLoadingMsg)">{{activeMsg}}</div>
            <div class="sub-msg" v-if="msg && !useLoadingMsg && !useGroundLoadingMsg">{{msg}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'travellers',
  data () {
    return {
      adults: 1,
      children: 0,
      infants: 0,
      activeMsg: '',
      activeIndex: 0,
      loadingMsgs: [
        'Don’t close now—your perfect deal is loading! This only takes up to a minute.',
        'Hold on! We’re searching the entire sky for the BEST flight deals—this may take up to a minute!',
        'Great deals take a few seconds to land! Stay with us while we find you the lowest price.',
        'Your flight is almost ready! Just a moment while we lock in the best rates for you.'
      ],
      groundLoadingMsgs: [
        "Don’t close now—your perfect ride is on the way! This only takes up to a minute.",
        "Hold on! We’re searching every route for the BEST ride options—this may take up to a minute!",
        "Great rides take a few seconds to arrive! Stay with us while we secure the lowest fare for you.",
        "Your ride is almost ready! Just a moment while we lock in the best route and price."
      ],
      delay: null
    }
  },
  computed: {
    other () { return this.$store.state.other },
    show () { return this.other.appLoader },
    msg () { return this.other.appLoaderMsg },
    useLoadingMsg () { return this.other.useLoadingMsg },
    useGroundLoadingMsg () { return this.other.useGroundLoadingMsg }
  },
  watch: {
    useLoadingMsg (x) {
      let self = this
      if (x) {
        self.activeMsg = self.loadingMsgs[self.activeIndex]
        if (this.delay) clearInterval(self.delay)
        self.delay = setInterval(function () {
          if (self.activeIndex === self.loadingMsgs.length - 1) self.activeIndex = 0
          else self.activeIndex += 1

          self.activeMsg = self.loadingMsgs[self.activeIndex]
        }, 10000)
      }
    },
    useGroundLoadingMsg (x) {
      let self = this
      if (x) {
        self.activeMsg = self.groundLoadingMsgs[self.activeIndex]
        if (this.delay) clearInterval(self.delay)
        self.delay = setInterval(function () {
          if (self.activeIndex === self.groundLoadingMsgs.length - 1) self.activeIndex = 0
          else self.activeIndex += 1

          self.activeMsg = self.groundLoadingMsgs[self.activeIndex]
        }, 1000)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.op--modal-container{
  overflow: auto;
  -webkit-overflow-scrolling:touch;
}

.loader-box{
  background-color: #fafafa;
  width: 300px;
  margin: 0 auto;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  font-family: 'Questrial', sans-serif;
  // padding: 30px;
  overflow: hidden;
  text-align: center;
}
.loader-icon-box{
  background: #fff;
  padding-bottom: 10px;
}
.app-imgloader{
  // height: 120px;
  width: 120px;
  // background: #eef6ff;
  background: #fff;
}
.msg-box{
  padding: 20px;
}
.search-flight{
  font-size: 21px;
  font-weight: 600;
  margin: 10px 0 5px;
}
.sub-msg{
  color: #75849f;
}
</style>



// WEBPACK FOOTER //
// AppLoader.vue?e508adf6